import { CompetitionStatusConstants } from '../../constants/CompetitionStatusConstants';
import { CompetitionEntryDTO } from '../../services/apiClient';
import { TableAction } from '../common/Table';
import { Check, X } from 'lucide-react';

interface CompetitionEntryActionHandlers {
  onConfirm: (entry: CompetitionEntryDTO) => void;
  onReject: (entry: CompetitionEntryDTO) => void;
}

const createCompetitionEntryActions =
  (handlers: CompetitionEntryActionHandlers) =>
    (row: CompetitionEntryDTO): TableAction[] => {
      const actions: TableAction[] = [];

      if (row.isDeleted || row.competitionStatusId === CompetitionStatusConstants.APPROVED || row.competitionStatusId === CompetitionStatusConstants.DECLINED) {
        return actions;
      }

      actions.push({
        label: 'Confirm',
        onClick: () => handlers.onConfirm(row),
        icon: <Check className="w-4 h-4" />,
        className: 'text-green-600 hover:text-green-700',
        confirmMessage: 'Are you sure you want to confirm this competition entry as paid?',
      });

      actions.push({
        label: 'Reject',
        onClick: () => handlers.onReject(row),
        icon: <X className="w-4 h-4" />,
        className: 'text-red-600 hover:text-red-700',
        confirmMessage: 'Are you sure you want to reject this competition entry?',
      });

      return actions;
    };

export default createCompetitionEntryActions;
